import component from "./component.js";
import { connect } from "react-redux";
import get from "lodash/get";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: () => {
      dispatch.ui.init();
    },
    logout: () => {
      dispatch.ui.logout();
    },
    link: () => {
      dispatch.account.linkAccountToSubscription();
    },
    savePocketmod: payload => {
      dispatch.editor.savePocketmod(payload);
    },
    newEmptyMod: payload => {
      dispatch.editor.newEmptyMod();
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    name: state.editor.name,
    desc: state.editor.desc,
    hasSubscription: state.account.hasSubscription,
    subscriptionReady: state.account.ready,
    isAdmin: get(state, "auth.profile.isAdmin", false),
    isLoggedIn: state.auth.isLoggedIn,
    isModDirty: state.ui.dirty
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(component);



// WEBPACK FOOTER //
// ./src/views/AppRoot/index.js